<template>
  <div />
</template>

<script>
export default {
  props: ['value', 'options', 'placeholder'],
  emits: [
    'onChange',
    'onFocus',
  ],
  mounted() {
    const component = this;
    const config = webix.copy({
      view: 'multiselectWithoutPoint',
      suggestCss: 'filterOptionSuggestIntegrationSlack',
      placeholder: this.placeholder,
      value: this.value,
      options: {
        body: {
          yCount: 6,
          data: this.options,
          template(item) {
            return `${item.value}`;
          }
        }
      },
      on: {
        onChange() {
          this.$scope.$emit('onChange', $$(component.webixId).getValue());
        },
        onFocus() {
          this.$scope.$emit('onFocus', component.webixId);
        }
      }
    });
    config.$scope = this;

    this.webixId = webix.ui(config, this.$el);
    $$(this.webixId).setValue(this.value);
  },
  unmounted() {
    webix.$$(this.webixId).destructor();
  }
};
</script>
